<app-navbar></app-navbar>
<div class="app-container">
<router-outlet></router-outlet>
<div class="footer">Arian Martínez 2021</div>
</div>